/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Ad_JobInputs */

const en_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic AD/DV Job`)
};

const fr_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi de publicité automatique`)
};

const de_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer AD-Job`)
};

const it_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro AD automatico`)
};

const ru_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое задание AD`)
};

const es_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo automático de AD`)
};

const zh_cn2_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动广告作业`)
};

const ja_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動ADジョブ`)
};

const hi_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित एडी जॉब`)
};

const pt_pt2_automatic_ad_job = /** @type {(inputs: Automatic_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa de anúncio automática`)
};

/**
* | output |
* | --- |
* | "Automatic AD/DV Job" |
*
* @param {Automatic_Ad_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_ad_job = /** @type {((inputs?: Automatic_Ad_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Ad_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_ad_job(inputs)
	if (locale === "de") return de_automatic_ad_job(inputs)
	if (locale === "it") return it_automatic_ad_job(inputs)
	if (locale === "ru") return ru_automatic_ad_job(inputs)
	if (locale === "es") return es_automatic_ad_job(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_ad_job(inputs)
	if (locale === "ja") return ja_automatic_ad_job(inputs)
	if (locale === "hi") return hi_automatic_ad_job(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_ad_job(inputs)
	return en_automatic_ad_job(inputs)
});